import { BoneModal } from './BoneModal';

let instances = [];

export function initModuleModals() {
	const pageBuilder = document.querySelector('.page-builder');
	if (!pageBuilder) {
		return;
	}


	const uninstantiated = Array.from(pageBuilder.querySelectorAll('.bonemodal'));
	if (!uninstantiated.length) {
		return;
	}

	uninstantiated.forEach(elem => {
		if (elem) {
			const modal = new BoneModal(elem);
			if (modal) {
				instances.push(modal);
			}
		}
	});
}



export function unloadModuleModals() {
	if (instances.length) {
		instances.forEach(instance => {
			instance.destroy();
		})
	}

	instances = [];
}



// WEBPACK FOOTER //
// ./scripts/modules/module-modals.js